import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  NavLink,
  Navigate,
  useLocation,
} from 'react-router-dom';
import './App.css';
import Contact from './Contact';
import About from './About';


function App() {
  return (
    <Router>
      <SiteLayout />
    </Router>
  );
}

function SiteLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Toggles menu visibility
  };

  // Close the menu when a link is clicked
  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Reset menuOpen state when resizing above 1000px
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1000 && menuOpen) {
        setMenuOpen(false); // Close the menu on large screens
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="App">
      <header className="App-header">
        <div className="topline">
          <div className="header-container">
            <Link to="/" className="logo" onClick={closeMenu}>PETER J. PUSTORINO</Link>
          </div>

          <nav className={`navbar ${menuOpen ? "open" : ""}`} aria-label="Primary">
            <ul>
              <li><NavLink to="/" end onClick={closeMenu}>Home</NavLink></li>
              <li><NavLink to="/about" onClick={closeMenu}>About</NavLink></li>
              <li><NavLink to="/contact" onClick={closeMenu}>Contact</NavLink></li>
            </ul>
          </nav>

          <button
            type="button"
            className={`ham-menu ${menuOpen ? "hidden" : ""}`}
            onClick={toggleMenu}
            aria-label="Open navigation menu"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <button
          type="button"
          className={`close-menu ${menuOpen ? "visible" : ""}`}
          onClick={toggleMenu}
          aria-label="Close navigation menu"
        >
          <span></span>
          <span></span>
        </button>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </header>
    </div>
  );
}

function Home() {
  return (
    <main className="herostuff">
      <div className="herocontainer">
        <h1 className="hero">25+ years of high quality<br /> mediation services</h1>
      </div>

      <div className="buttongroup">
        <Link className="button-link learnmore" to="/about">
          Learn More
        </Link>
        <Link className="button-link contactus" to="/contact">
          Contact Us
        </Link>
      </div>
    </main>
  );
}

export default App;
